import jwtDecode from 'jwt-decode';

import bugsnagClient from '../clients/bugsnag-client';


export const updateUserInfo = (token) => {
  if (token) {
    const { id } = jwtDecode(token);

    bugsnagClient.user = {
      id,
    };

    gtag('set', { user_id: id });
  } else {
    bugsnagClient.user = undefined;
    gtag('set', { user_id: undefined });
  }
};

export const logEvent = (eventName, metadata) => {
  /* global gtag */
  gtag('event', eventName, {
    event_category: 'LysterEvent',
    ...metadata,
  });
};
